import React, { forwardRef, useCallback } from "react";
import Input from "@/components/ui/input";

interface Props {
  placeholder: string;
  defaultValue: string | number;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterNumericInput = forwardRef<HTMLInputElement, Props>(
  ({ placeholder, defaultValue, onKeyDown, onChange }, ref) => {
    const handleKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Allow: backspace, delete, tab, escape, enter, decimal point
        const allowedKeys = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          ".",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End"
        ];

        // Allow Ctrl/Cmd + A, C, V, X
        if (
          (e.ctrlKey || e.metaKey) &&
          ["a", "c", "v", "x"].includes(e.key.toLowerCase())
        ) {
          onKeyDown(e);
          return;
        }

        // Allow allowed keys
        if (allowedKeys.includes(e.key)) {
          onKeyDown(e);
          return;
        }

        // Allow numbers 0-9
        if (/^[0-9]$/.test(e.key)) {
          onKeyDown(e);
          return;
        }

        // Block everything else
        e.preventDefault();
      },
      [onKeyDown]
    );

    return (
      <Input
        ref={ref}
        type="text"
        inputMode="decimal"
        placeholder={placeholder}
        defaultValue={defaultValue}
        onKeyDown={handleKeyDown}
        onChange={onChange}
      />
    );
  }
);

FilterNumericInput.displayName = "FilterNumericInput";

export default FilterNumericInput;
